import api from "./apis/api";
import { logger } from "../utils/utils";

class FarmerService {
  createFarmerApi(farmeReq) {
    // logger("FarmerService", "createFarmerApi");
    return api.farmer.createFarmerApi(farmeReq);
  }

  getFarmerApi(farmeReq) {
    // logger("FarmerService", "getFarmerApi");
    return api.farmer.getFarmerApi(farmeReq);
  }

  getFarmerDetailsById(farmerId) {
    // logger("FarmerService", "getFarmerDetailsById");
    return api.farmer.getFarmerDetailsById(farmerId);
  }

  updateFarmerDetails(farmeDataReq) {
    logger("FarmerService", "updateFarmerDetails");
    return api.farmer.updateFarmerDetails(
      farmeDataReq?.farmerId,
      farmeDataReq?.payload,
    );
  }

  uploadFarmerPhoto(farmeReq) {
    logger("FarmerService", "uploadFarmerPhoto");
    return api.farmer.uploadFarmerPhoto(farmeReq);
  }

  createFarmInspection(inspectionReq) {
    // logger("FarmerService", "createFarmInspection");
    return api.farmer.createFarmInspection(inspectionReq);
  }

  updateFarmInspection(inspectionReq) {
    // logger("FarmerService", "updateFarmInspection");
    return api.farmer.updateFarmInspection(
      inspectionReq?.inspectionId,
      inspectionReq?.payload,
    );
  }

  deleteFarmInspection(inspectionId) {
    return api.farmer.deleteFarmInspection(inspectionId);
  }

  getFarmInspection(inspectionReq) {
    // logger("FarmerService", "getFarmInspection");
    return api.farmer.getFarmInspection(inspectionReq);
  }

  createHarvesting(inspectionReq) {
    // logger("FarmerService", "createHarvesting");
    return api.farmer.createHarvesting(inspectionReq);
  }

  getFarmHarvesting(inspectionReq) {
    // logger("FarmerService", "getFarmHarvesting");
    return api.farmer.getFarmHarvesting(inspectionReq);
  }

  updateHarvesting(inspectionReq) {
    logger("FarmerService", "updateHarvesting");
    const payload =
      inspectionReq?.payload !== undefined
        ? inspectionReq?.payload
        : inspectionReq?.inspectionReq !== undefined
        ? inspectionReq?.inspectionReq
        : inspectionReq;
    return api.farmer.updateHarvesting(
      inspectionReq?.harvestingId,
      payload,
    );
  }

  sendToFermentation(harvestingReq) {
    logger("FarmerService", "sendToFermentation");
    return api.farmer.sendToFermentation(harvestingReq);
  }
}

export default new FarmerService();
